import { generatePath } from 'react-router';
import { utils as cloudTypeUtils, constants as cloudTypeConstants } from '@saucelabs/sl-module-cloudtype';

import {
  TESTS_PAGE_STATUSES,
  STORAGE_TESTS_KEY,
  STORAGE_TESTS_RDC_KEY,
  TEST_OVERVIEW_PATH,
} from './../../../constants';
import { TestCaseRecord } from './../../../records';

/**
 *
 * @param {Object[]} testCases
 * @param {string} status
 * @returns {Immutable.Record[]}
 */
export const filterTestCases = (testCases, status) => {
  let items = testCases;
  if (status === TESTS_PAGE_STATUSES.inconsistent.status) {
    items = testCases.filter(({ statuses }) => Object.keys(statuses).length > 1);
  }

  return items.map((testCase) => new TestCaseRecord(testCase));
};

/**
 * Gets proper test type (status) key,
 * in order to be used in dynamic pathname
 * @param {string} key
 * @param {string} cloudType
 * @returns {string}
 */
export const getTypeParam = (key, cloudType) => {
  if (!key) {
    if (cloudType === cloudTypeConstants.CLOUD_VIRTUAL) {
      return window.localStorage.getItem(STORAGE_TESTS_KEY);
    }

    if (cloudType === cloudTypeConstants.CLOUD_REAL) {
      return window.localStorage.getItem(STORAGE_TESTS_RDC_KEY);
    }

    return TESTS_PAGE_STATUSES.all.key;
  }

  return key;
};

/**
 * Makes url and replaces variables with correct values.
 * Uses react-router generatePath() method
 * @param {object} params
 * @returns {string}
 */
export const getPathWithTestStatus = ({
  tabName,
  cloudTypeKey,
  statusKey,
  pathPattern = TEST_OVERVIEW_PATH,
}) => {
  const cloudType = cloudTypeUtils.getCloudType(cloudTypeKey, true);
  const newPathname = generatePath(`/analytics${pathPattern}`, {
    tabName,
    cloudType,
    type: getTypeParam(statusKey, cloudType),
  });

  return newPathname;
};
